<template>

    <div>

        <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" ref="form">

            <input type="hidden" name="stay-on-page" v-model="stayOnPage">

            <div class="form-group">
                <label>Logo partnera</label>
                <file-manager-image-select :input-name="'partner_logo'" :value="form.partner_logo" v-model="form.partner_logo" :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'" :crop-available="true" :crop-aspect-ratio="370/165" :width="370"></file-manager-image-select>
                <span class="error mt-2 text-danger" v-if="form.errors.has('partner_logo')" v-text="form.errors.get('partner_logo')"></span>
            </div>

            <div class="form-group">
                <label for="sensitivity">Czułość</label>
                <input type="number" min="0" max="20" step="1" class="form-control" id="sensitivity" v-model="form.sensitivity" :placeholder="defaultValues.sensitivity">
                <span class="error mt-2 text-danger" v-if="form.errors.has('sensitivity')" v-text="form.errors.get('sensitivity')"></span>
            </div>

            <div class="form-group">
                <label for="sensitivity">Rodzaj wygaszacza ekranu</label>
                <select id="screensaver_type" class="form-control" v-model="form.screensaver_type">
                    <option value="image">Obraz</option>
                    <option value="video">Wideo</option>
                    <option value="game">Gra</option>
                </select>
                <span class="error mt-2 text-danger" v-if="form.errors.has('screensaver_type')" v-text="form.errors.get('screensaver_type')"></span>
            </div>

            <div class="form-group" v-if="form.screensaver_type === 'image'">
                <label>Wygaszacz ekranu (obraz)</label>
                <file-manager-image-select :input-name="'screensaver'" :value="form.screensaver" v-model="form.screensaver" :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'" :crop-available="true" :crop-aspect-ratio="16/9" :width="370"></file-manager-image-select>
                <span class="error mt-2 text-danger" v-if="form.errors.has('screensaver')" v-text="form.errors.get('screensaver')"></span>
            </div>

            <div class="row" v-if="form.screensaver_type === 'video'">
                <div class="col-lg-4 col-md-6">
                    <div class="form-group">
                        <label>Wygaszacz ekranu (wideo)</label>
                        <file-manager-file-select :input-name="'screensaver'" :value="form.screensaver" v-model="form.screensaver" :mime-types="'video/mp4'"></file-manager-file-select>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('screensaver')" v-text="form.errors.get('screensaver')"></span>
                    </div>
                </div>
            </div>

            <div class="form-group" v-if="form.screensaver_type === 'game'">
                <label for="screensaver_value">Wygaszacz ekranu (gra)</label>
                <select class="form-control" id="screensaver_value" v-if="screensaverGamesOptions.length > 0" v-model="form.screensaver_value">
                    <option :value="null" disabled selected>Wybierz</option>
                    <option v-for="screensaverGamesOption in screensaverGamesOptions" :value="screensaverGamesOption.id">{{ screensaverGamesOption.text }}</option>
                </select>
                <input type="text" class="form-control" id="screensaver_value" v-if="screensaverGamesOptions.length === 0" v-model="form.screensaver_value" :placeholder="defaultValues.screensaver_game">
                <span class="error mt-2 text-danger" v-if="form.errors.has('screensaver_value')" v-text="form.errors.get('screensaver_value')"></span>
            </div>

            <div class="form-group">
                <label for="screensaver_time_menu">Czas wygaszacza ekranu - menu</label>
                <input type="number" min="0" step="1" class="form-control" id="screensaver_time_menu" v-model="form.screensaver_time_menu" :placeholder="defaultValues.screensaver_time_menu">
                <span class="error mt-2 text-danger" v-if="form.errors.has('screensaver_time_menu')" v-text="form.errors.get('screensaver_time_menu')"></span>
            </div>

            <div class="form-group">
                <label for="screensaver_time_game">Czas wygaszacza ekranu - gra</label>
                <input type="number" min="0" step="1" class="form-control" id="screensaver_time_game" v-model="form.screensaver_time_game" :placeholder="defaultValues.screensaver_time_game">
                <span class="error mt-2 text-danger" v-if="form.errors.has('screensaver_time_game')" v-text="form.errors.get('screensaver_time_game')"></span>
            </div>

            <div class="form-group">
                <label for="godot_bin">Ścieżka katalogu z plikami binarnymi dla Godot</label>
                <input type="text" class="form-control" id="godot_bin" v-model="form.godot_bin" :placeholder="defaultValues.godot_bin">
                <span class="error mt-2 text-danger" v-if="form.errors.has('godot_bin')" v-text="form.errors.get('godot_bin')"></span>
            </div>

        </form>

    </div>

</template>

<script>

    import Image from "../../../../../FileManager/Resources/assets/js/classes/Image";

    export default {

        name: 'MachineMenuForm',

        props: [
            'machineInput',
            'defaultValues',
            'screensaverGames'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                machine: null,
                form: null,
                stayOnPage: false,
                screensaverGamesOptions: []
            }
        },

        beforeMount() {

            this.machine = this.machineInput;

            this.screensaverGames.forEach(screensaverGame => {
                this.screensaverGamesOptions.push({
                    text: screensaverGame.display_name,
                    id: screensaverGame.output_identification_name
                });
            });

            this.form = new Vue.prototype.Form({
                partner_logo: new Image(this.machine.menu.partner_logo_url),
                sensitivity: this.machine.menu.sensitivity,
                screensaver_type: this.machine.menu.screensaver_type,
                screensaver: new Image(this.machine.menu.screensaver_url),
                screensaver_value: this.machine.menu.screensaver_value,
                screensaver_time_menu: this.machine.menu.screensaver_time_menu,
                screensaver_time_game: this.machine.menu.screensaver_time_game,
                godot_bin: this.machine.menu.godot_bin
            });

        },

        created () {
            this.eventHub.$on('submit-form', (stay) => {
                this.stayOnPage = stay;
                this.onSubmit();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('submit-form')
        },

        methods: {

            onSubmit() {
                this.form.put(route('machine::machines.update-menu', {id: this.machine.id}))
                    .then(response => {
                        if (this.stayOnPage) {
                            this.machine = response.data.machine;
                            this.form.setData({
                                partner_logo: new Image(this.machine.menu.partner_logo_url),
                                sensitivity: this.machine.menu.sensitivity,
                                screensaver_type: this.machine.menu.screensaver_type,
                                screensaver: new Image(this.machine.menu.screensaver_url),
                                screensaver_value: this.machine.menu.screensaver_value,
                                screensaver_time_menu: this.machine.menu.screensaver_time_menu,
                                screensaver_time_game: this.machine.menu.screensaver_time_game,
                                godot_bin: this.machine.menu.godot_bin
                            });
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        } else {
                            window.location.href = route('machine::machines.index') + '?status-message=success:' + response.message;
                        }
                    })
                    .catch(response => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                    });
            }

        }
    }

</script>

<style scoped>

    /deep/ .select2-container { width: 100% !important; }

</style>
